import fetchBotStatus from './fetchBotStatus';

export const getBotStatus = (chatbotStatusIsOnline, recommenderStatusIsOnline) => {
  const chatbotUrl =
    '/api/v1/bot-status/status';

  const recommenderUrl =
    '/api/v1/bot-status/recommender';

  fetchBotStatus(chatbotUrl)
    .then(response => {
      chatbotStatusIsOnline.value = response;
    });

  fetchBotStatus(recommenderUrl)
    .then(response => {
      recommenderStatusIsOnline.value = response;
    });
}
